import angular = require('angular');
import { IPopupSettings } from '../../models';
import { PopupServiceCancel } from '../../models/popupServiceCancel';

class ConfirmPopupModalInstance {
    public static $inject = ['$sce'];

    public title: string;
    public body: string;
    public okTxt: string;
    public cancelTxt: string;
    public okClass: string;
    public cancelClass: string;
    public hideCloseCross: boolean;
    public hasIcon: boolean;
    public thinTitle: boolean;
    public noCancelButton: boolean;

    private  resolve: {
        settings: IPopupSettings
    };
    private modalInstance: ng.ui.bootstrap.IModalServiceInstance = this as any;

    constructor(private $sce: ng.ISCEService) { }

    public $onInit() {
        const settings = this.resolve.settings;
        this.title = settings.title;

        this.body = this.$sce.trustAsHtml(settings.content);

        this.okTxt = settings.okTxt || 'Yes';
        this.cancelTxt = settings.cancelTxt || 'No';

        this.okClass = 'btn ' + (settings.okClass || (settings.invertAction ? 'color-black54 bg-dark12' : 'btn-success'));
        this.cancelClass = 'btn ' + (settings.cancelClass || (!settings.invertAction ? 'color-black54 bg-dark12' : 'btn-danger'));

        this.hideCloseCross = settings.hideCloseCross || false;

        this.hasIcon = settings.hasIcon || false;

        this.thinTitle = settings.thinTitle || false;
        this.noCancelButton = settings.noCancelButton || false;
    }

    public ok() {
        if (this.resolve.settings.invertAction) {
            this.modalInstance.dismiss({ $value: new PopupServiceCancel('cancel') });
        } else {
            this.modalInstance.close({ $value: 'closed' });
        }
    }

    public cancel() {
        if (this.resolve.settings.invertAction) {
            this.modalInstance.close({ $value: 'closed' });
        } else {
            this.modalInstance.dismiss({ $value: new PopupServiceCancel('cancel') });
        }
    }

    public closeup() {
        if (this.resolve.settings.closeOk) {
            this.modalInstance.close({ $value: 'closed' });
        } else {
            this.modalInstance.dismiss({ $value: new PopupServiceCancel('cancel') });
        }
    }
}

angular.module('app.common')
    .component('confirmPopup', {
        template: require('./confirmPopup.html'),
        controller: ConfirmPopupModalInstance,
        controllerAs: 'vm',
        bindings: {
            resolve: '=',
            close: '&',
            dismiss: '&'
        }

    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/confirmPopup/confirmPopup.component.ts